import ThaiId from './smartCard/ThaiId'

export const SMART_CARD_OPTIONS = [{ label: 'บัตรประชาชน', value: 'thaiId' }]

const SmartCard = (props) => {
  let { action } = props
  let { cardType } = action

  switch (cardType) {
    case 'thaiId':
      return <ThaiId {...props} />
    default:
      return <>CARD</>
  }
}

export default SmartCard
